module.exports = __webpack_public_path__ + "static/media/kitchen5.720ed78e.png";